export const AUTHORIZATION_PENDING = 'P';
export const AUTHORIZATION_APPROVED = 'A';
export const AUTHORIZATION_EXPIRED = 'E';
